module.exports = __webpack_public_path__ + "static/media/ic-edit.5c6907b1.svg";